module.exports = __webpack_public_path__ + "img/cart.8db91185.jpg";